import React, { useState } from 'react';

const AggregateSmsHistory = ({ trainerSmsHistory, trainerSmsLoading, formatLocalDateTime }) => {
  const [expanded, setExpanded] = useState(false);
  if (trainerSmsLoading) {
    return (
      <button
        disabled
        style={{ width: '100%', display: 'block', margin: '0 auto 1rem auto', padding: '1rem', borderRadius: '8px', border: 'none', background: 'rgba(255, 193, 7, 0.1)', color: '#eee', fontWeight: 'bold', cursor: 'not-allowed', opacity: 0.7 }}
      >
        Loading SMS history...
      </button>
    );
  }
  if (trainerSmsHistory.length === 0) {
    return (
      <button
        disabled
        style={{ width: '100%', display: 'block', margin: '0 auto 1rem auto', padding: '1rem', borderRadius: '8px', border: 'none', background: 'rgba(255, 193, 7, 0.1)', color: '#eee', fontWeight: 'bold', cursor: 'not-allowed', opacity: 0.7 }}
      >
        <h2>SMS History Logs</h2>
        No SMS messages have been sent to your clients yet.
      </button>
    );
  }
  return (
    <div className="fogged-card" style={{ backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'white', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem 1rem', borderRadius: '6px', border: 'none', background: '#ffc107', color: '#222', fontWeight: 'bold', cursor: 'pointer', display: 'block' }}
      >
        {expanded ? 'Hide' : 'Show'} Aggregate SMS History - ({trainerSmsHistory.length} message{trainerSmsHistory.length > 1 ? 's' : ''})
      </button>
      {expanded && (
        <div
          style={{
            maxHeight: '300px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '1rem',
            marginTop: '2rem',
            backgroundColor: 'rgba(0,0,0,0.3)'
          }}
        >
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {trainerSmsHistory.map((sms, index) => (
              <li key={index} style={{ marginBottom: '1rem',
                backgroundColor: 'rgba(34, 181, 34, 1)',
                color: 'white',
                borderRadius: '8px',
                padding: '0.5rem' }}>
                <p><b>From:</b> {sms.sender_id} {sms.sender_id && '/'}{!sms.sender_id && 'Unknown'} {sms.sender?.user?.name}</p>
                <p><b>To:</b> {sms.recipient_id} at {sms.recipient_phone_number}</p>
                <p><b>Message:</b> {sms.content}</p>
                <p><b>Sent At:</b> {formatLocalDateTime(sms.sent_at)}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AggregateSmsHistory;
